// Module
var code = "{{vm.field}}<legend>{{ vm.field.name }}</legend> ";
// Exports
module.exports = code;